__turbopack_context__.v({
  "indicator": "SearchBox-module-scss-module__1VzVzq__indicator",
  "input": "SearchBox-module-scss-module__1VzVzq__input",
  "rainbow": "SearchBox-module-scss-module__1VzVzq__rainbow",
  "reset": "SearchBox-module-scss-module__1VzVzq__reset",
  "root": "SearchBox-module-scss-module__1VzVzq__root",
  "section": "SearchBox-module-scss-module__1VzVzq__section",
  "submit": "SearchBox-module-scss-module__1VzVzq__submit",
});
